export default __webpack_public_path__ + "static/media/iconMobileWhite.6181e7e3.svg";